import React from 'react'
import { connect } from "react-redux";

import { Form } from 'react-form'

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import {InputText} from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { Checkbox } from 'primereact/checkbox';
import { Toolbar } from 'primereact/toolbar'

import * as appActionCreators from "../actionCreators/app.js";
import * as authActionCreators from "../actionCreators/auth.js";
import * as lookupCodeActionCreators from "../actionCreators/lookupCode.js";
import * as lookupCodeTypeActionCreators from "../actionCreators/lookupCodeType.js";

import { REGION, GENDER, QUALIFICATION, SKILL, ROLE_ADMIN } from '../js/const'


import '../css/maintain-lookups.css'

class MaintainLookups extends React.Component{
    constructor (props) {
        super(props)
        this.state = {
            selected: {},
            newRecord: false,
            displayDialog: false,
            lookupCode: {}
        }       

        this.save = this.save.bind(this);
        this.delete = this.delete.bind(this);
        this.onRecordSelect = this.onRecordSelect.bind(this);
        this.addNew = this.addNew.bind(this);
    }

    componentDidMount() {
        //is invoked immediately after a component is mounted.
        //Initialization that requires DOM nodes should go here. If you need to load data from a remote endpoint, this is a good place to instantiate the network request.
        this.props.setLoading(true)
            .then(() => this.props.getLookupCodeTypes())
            .then(() => this.props.getQualifications(false))
            .then(() => this.props.getRegions(false))
            .then(() => this.props.getGenders(false))
            .then(() => this.props.getSkills(false))
            .then(() => this.props.setLoading(false))
            .catch((error) => { this.props.handleError(error)
                                    .then(() => this.props.setLoading(false))})
    }

    saveLookupCodeChanges = lookupCodes => {
        this.props.setLoading(true)
            .then(() => {                
                this.props.updateLookupCode(lookupCodes)
                    .then(response => {
                        this.props.setAjaxResponse(response)
                        this.props.setLoading(false)
                        if (response.data.Success) {
                            this.props.getQualifications(false)
                            this.props.getRegions(false)
                            this.props.getGenders(false)
                            this.props.getSkills(false)
                        }
                    })                
            })
            .catch((error) => this.props.handleError(error)
                .then(() => this.props.setLoading(false)))
    }

    deleteLookupCode = lookupCodeId => {
        this.props.setLoading(true)
            .then(() => {                
                this.props.deleteLookupCode(lookupCodeId)
                    .then(response => {
                        this.props.setAjaxResponse(response)
                        this.props.setLoading(false)
                        if (response.data.Success) {
                            this.props.getQualifications(false)
                            this.props.getRegions(false)
                            this.props.getGenders(false)
                            this.props.getSkills(false)
                        }
                    })                
            })
            .catch((error) => this.props.handleError(error)
                                .then(() => this.props.setLoading(false)))
    }

    save() {
        if(this.state.newRecord){
            let newState = Object.assign({}, this.state);
            newState.lookupCode.CodeType = this.state.selected.CodeType

            if(newState.lookupCode.Description.trim() !== "" ){
                this.setState(newState);
                this.saveLookupCodeChanges(newState.lookupCode)
                this.setState({ displayDialog: false });
                return;
            }
        }
        else{
            this.saveLookupCodeChanges(this.state.lookupCode)
        }

        this.setState({ displayDialog: false });
    }

    delete() {        
        this.deleteLookupCode(this.state.lookupCode.CodeLovId)
        this.setState({ displayDialog: false });
        return;
    }

    findSelectedRecordIndex() {
        return this.props.lookupCode.lookupCodes.indexOf(this.state.selectedLookupCode);
    }

    updateProperty(property, value) {
        let lookupCode = this.state.lookupCode;
        lookupCode[property] = value;
        this.setState({lookupCode: lookupCode});
    }

    onRecordSelect(e){
        this.setState({
            displayDialog:true,
            lookupCode: Object.assign({}, e.data),
            newRecord: false
        });
    }

    addNew() {
        this.setState({
            lookupCode: {SystemCode:'', Description: '', CodeType: '',SequenceNo:''},
            displayDialog: true,
            addRecord: true,
            newRecord: true
        });
    }

    onSelectionChange = (e) => {
        this.setState({selected: e.value})
    }

    activeFlag = (lookupCodes) => {
        return <span><Checkbox checked={lookupCodes.Active} /> </span>
    }

    render() {
        let isAdmin = this.props.auth.roles && this.props.auth.roles.some(role => role === ROLE_ADMIN)
        let footer = <div className="p-clearfix">
            {this.state.selected && this.state.selected.CodeType && <Button icon="pi pi-plus" label="Add" onClick={this.addNew}/>}
        </div>

        let header = <div className="p-clearfix" style={{width:'250px'}}>
                        <Dropdown value={this.state.selected} options={this.props.lookupCodeType.lookupCodeTypes} onChange={(e) => this.onSelectionChange(e)} 
                            style={{width: '100%', top: '0.1em'}} placeholder="System Code Type" optionLabel="CodeType" />                        
                    </div>        

        let dialogFooter =        
             <Toolbar>
                <div className="p-toolbar-group-left">
                  <Button style={{marginBottom:"5px"}}  label="Save" icon="pi pi-check" onClick={this.save} />
                  {this.state.newRecord === false &&   <Button style={{marginBottom:"5px"}} disabled={this.state.lookupCode.SystemCode} icon="pi pi-times" label="Delete" onClick={this.delete} /> }             
                </div> 
             </Toolbar>
   

        let lookupCodes = this.props.lookupCode.lookupCodes        

        if (this.state.selected && this.state.selected.CodeType) {
            if(this.state.selected.CodeType === GENDER) {
                lookupCodes = this.props.lookupCode.genders
            }
            else if (this.state.selected.CodeType === QUALIFICATION) {
                lookupCodes = this.props.lookupCode.qualifications
            }
            else if (this.state.selected.CodeType === SKILL) {
                lookupCodes = this.props.lookupCode.skills
            }
            else if (this.state.selected.CodeType === REGION) {
                lookupCodes = this.props.lookupCode.regions
            }
        }
        
        return (
            <React.Fragment>
                {isAdmin && <Form values={this.state.lookupCodes} onSubmit={this.saveLookupCodeChanges}>
                    {formApi => {
                        return ( 
                        <div>
                            <h1>Lookup Codes</h1>
                            <DataTable value={lookupCodes} footer={footer} editable={true} selectionMode="single"
                                    selection={this.state.selectedLookupCode} onSelectionChange={(e)=>{this.setState({selectedLookupCode:e.data});}}
                                    onRowSelect={this.onRecordSelect}
                                    className="candidate-table p-datatable-hoverable-rows" filters={true}
                                    paginator={true} rows={10}
                                    header={header} >
                                
                                <Column field="Description" header="Description" sortable={true} filter={true} filterMatchMode="contains" />
                                <Column field="SequenceNo" header="Sequence No." sortable={true} />
                                <Column field="Active" header="Active" body={this.activeFlag} />
                            </DataTable>

                            <Dialog visible={this.state.displayDialog}  header="Lookup Code details" modal={true} footer={dialogFooter}
                                onHide={() => this.setState({displayDialog: false})}>
                            {this.state.lookupCode &&
                                <div className="p-grid p-fluid">
                                    <div className="p-col-12" id="description">
                                       <label htmlFor="Description">Description</label>
                                        <InputText id="Description" onChange={(e) => {this.updateProperty('Description', e.target.value)}} value={this.state.lookupCode.Description}/>                             
                                    </div>
                                    <div className="p-col-12" id="sequenceNo">
                                      <label htmlFor="SequenceNo">Sequence No.</label>
                                       <InputText id="SequenceNo" keyfilter="num" onChange={(e) => {this.updateProperty('SequenceNo', e.target.value)}} value={this.state.lookupCode.SequenceNo}/>  
                                    </div>
                                    <div className="p-col-8" id="active">               
                                        <Checkbox id="Active" onChange={(e) => {this.updateProperty('Active', e.checked)}} checked={this.state.lookupCode.Active}/>
                                        <label htmlFor="Active" className="p-checkbox-label">Active</label>
                                    </div>
                                </div>
                               
                            }
                            </Dialog>
                        </div>
                        )
                    }}
                </Form>}
            </React.Fragment>
        )
    }
}

const mapStateToProps=(state)=>{
    return state
}

const actionCreators = {
    ...appActionCreators,
    ...authActionCreators,
    ...lookupCodeActionCreators,
    ...lookupCodeTypeActionCreators
}

export default connect (mapStateToProps, actionCreators)(MaintainLookups);


// WEBPACK FOOTER //
// ./src/container/LookupCode.js